import { useNProgress } from '@tanem/react-nprogress'
import cn from 'classnames'
import s from './NanoProgress.module.scss'

type NanoProgressType = {
    isAnimating: boolean
    minimum?: number
    incrementDuration?: number
    backgroundColor?: string | null
}

const NanoProgress: React.FC<NanoProgressType> = ({
    isAnimating,
    minimum = 0.35,
    incrementDuration = 350,
    backgroundColor
}) => {
    const { animationDuration, isFinished, progress } = useNProgress({
        isAnimating,
        minimum,
        incrementDuration
    })

    return (
        <div
            className={cn(
                s['container'],
                isFinished ? 'opacity-0' : 'opacity-100'
            )}
            style={{
                transition: `opacity ${animationDuration}ms linear`
            }}
        >
            <div
                className={cn(s['bar'], backgroundColor)}
                style={{
                    marginLeft: `${(-1 + progress) * 100}%`,
                    transition: `margin-left ${animationDuration}ms linear`
                }}
            />
        </div>
    )
}

export default NanoProgress
